import Breadcrumbs from "../../components/BreadCrumbs/Breadcrumbs";

export default function BreadCrumbsScreen() {
  return <Breadcrumbs />;
}
